import styles from "./index.module.less";
import Icon from "@/components/Icon";
import QRCode from "@/assets/img/web2x_pic_erweima.png";
import logo from "@/assets/img/logo-rev-screen.png";

const Footer = () => {
  return (
    <div className={styles["footer-view"]}>
      <div className="footer-content">
        <div className="footer-content-left">
          <div className="line-box" />
          <div className="footer-content-left-logo">
            <img data-v-16d0b352="" src={logo} alt="logo" />
          </div>
          <div className="footer-content-left-text">
            <div>京 ICP 证 110182 号 | (京)-经营性-2015-0003</div>
            <div>
              © UpToDate, Inc. and/or its affiliates. All rights reserved.
            </div>
            <div>热线电话：028-87526280 赛事邮箱：health@wolterskluwer.cn</div>
          </div>

          <div className="footer-content-left-icon">
            <Icon icon="Group39" style={{ fontSize: "32px" }} />
            <Icon icon="Group40" style={{ fontSize: "32px" }} />
            <Icon icon="Group41" style={{ fontSize: "32px" }} />
            <Icon icon="Group42" style={{ fontSize: "32px" }} />
          </div>
        </div>

        <div className="footer-content-right">
          <div className="line-box" />
          <img src={QRCode} alt="logo" />
          <div className="footer-content-right-text">
            关注UpToDate临床顾问速递微信平台获取更多大赛相关信息
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
